import React from 'react'
import clsx from 'clsx'
import { RichUtils } from 'draft-js'
import DoNotTranslateIcon from 'app/components/richTextEditor/DoNotTranslateIcon'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(() => ({
  toggleNoTranslate: {
    color: '#064e75 !important',
  },
  noTranslate: {
    color: 'rgba(0, 0, 0, 0.54) !important',
    border: '0 !important',
  },
}))

const NOTRANSLATE_TAGS = 'DONOTTRANSLATE'

export default (props) => {
  const { editorState, onUpdateEditorState } = props
  const classes = useStyles()
  const hasDoNotTranslate = editorState
    .getCurrentInlineStyle()
    .has(NOTRANSLATE_TAGS)

  const doNotTranslate = () => {
    const newEditorState = RichUtils.toggleInlineStyle(
      editorState,
      NOTRANSLATE_TAGS,
    )

    onUpdateEditorState(newEditorState)
  }

  return (
    <div aria-haspopup="true" className="rdw-inline-wrapper">
      <div
        className={clsx(
          'rdw-option-wrapper',
          hasDoNotTranslate ? classes.toggleNoTranslate : classes.noTranslate,
        )}
        onClick={doNotTranslate}
      >
        <DoNotTranslateIcon />
      </div>
    </div>
  )
}
